import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=42e8db15&lang=pug&"
import script from "./ColorField.vue?vue&type=script&lang=js&"
export * from "./ColorField.vue?vue&type=script&lang=js&"
import style0 from "./ColorField.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e8db15')) {
      api.createRecord('42e8db15', component.options)
    } else {
      api.reload('42e8db15', component.options)
    }
    module.hot.accept("./ColorField.vue?vue&type=template&id=42e8db15&lang=pug&", function () {
      api.rerender('42e8db15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/ColorField.vue"
export default component.exports